import { z } from 'zod'

export const AssignEmployeesSchema = () => {
  return z.object({
    employeeSelection: z.object({
      type: z.literal('manual'),
      ids: z.array(z.number()),
    }),
  })
}

export type AssignEmployeesSchemaType = z.infer<ReturnType<typeof AssignEmployeesSchema>>
